<template>
  <el-dialog title="修改用户资料" :visible.sync="updateUserInfoDialog" width="800px"  v-show="updateUserInfoDialog"  append-to-body>
    <el-form ref="updateUserInfoForm" :model="addRow" :rules="rules" label-width="120px" >
      <el-form-item class="row" label="头像" prop="headPic" >
        <upload type="1" v-model="addRow.headPic"></upload>
      </el-form-item>
      <el-form-item class="row" label="帐号">
       <span>{{addRow.userName}}</span>
      </el-form-item>
      <el-form-item class="row" label="用户名称" prop="nickName" >
        <el-input  class="w300" v-model="addRow.nickName"></el-input>
      </el-form-item>
      <el-form-item class="row" label="手机号码" prop="mobile" >
        <el-input  class="w300" v-model="addRow.mobile"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="flex-e">
        <el-button @click="cancel()">取 消</el-button>
        <el-button @click="updatePassword()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
  import '../../../static/plugin/jquery.form'
  import '../../../static/plugin/jquery.jcryption.3.1.0'
  import Upload from "../upload/upload";

  export default {
    props:{
      value:{
        type:Boolean,
        default:false,
      }
    },
    name: "updateUserInfo",
    components: {Upload},
    data() {
      return {
        updateUserInfoDialog: false,
        addRow: {id:"",headPic:"",mobile:"",nickName:"",userName:""},
        source:source,
        rules: {
          headPic: [
            {required: true, message: '请上传头像', trigger: 'blur'},
          ],
          nickName: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
          ],
          mobile:[
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {pattern: mobilePass, message: '请输入正确的手机号码',trigger: 'blur'}
          ]
        }
      }
    },
    watch:{
      value(n){
        if(n){
          this.updateUserInfoDialog = true;
        }
      }
    },
    mixins: [tableBase],
    methods: {
      updatePassword() {
        this.$refs['updateUserInfoForm'].validate((valid) => {
          if (valid) {
            this.submitForm();
          }
        });
      },
      submitForm(){
        this.simplePost("/api/mgr/user/addOrUpdate", {id:this.addRow.id,headPic:this.addRow.headPic,nickName:this.addRow.nickName,mobile:this.addRow.mobile},result => {
          let user = this.$store.state.user;
          user.headPic = this.addRow.headPic;
          user.nickName = this.addRow.nickName;
          user.mobile = this.addRow.mobile;
          this.$store.commit("addUser",user);
          this.cancel();
        });
      },
      cancel(){
        this.updateUserInfoDialog =false;
        this.$emit("update:modelValue", false);
      },
    },
    mounted() {
      let user = this.$store.state.user;
      this.source = user.source;
      this.addRow = {id:user.id,source:this.source,headPic:user.headPic,userName:user.userName,nickName:user.nickName,mobile:user.mobile}
    }
  }
</script>


<style lang="less" scoped>

</style>
